import React from "react";
import Reference from "./reference";

// import "./references-block.css";
import { Box, Flex, Text } from "theme-ui";
import { colors, typography } from "../../styles/theme";
const ReferencesBlock = ({ references }) => {
  if (!references.length) {
    return null;
  }

  return (
      <Flex sx={{ gap: "1rem", flexDirection: "column" }}>
      <Text sx={{ ...typography.h6 }}>Referred in</Text>
      <Box
        sx={{
          border: `1px solid ${colors.neutral200}`,
          borderRadius: "1.25rem",
          overflow: "hidden",
        }}
      >
        {references.map((ref, index) => (
          <Reference
            node={ref}
            key={ref.id}
            isFirst={index === 0}
            isLast={references.length === index + 1}
          />
        ))}
      </Box>
    </Flex>
  );
};

export default ReferencesBlock;
